import React from 'react';
import styled from 'styled-components';
import ModalFooterLink from '../components/Links/ModalFooterLink';

const WrapperDiv = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #6e7582;
  a.link {
    color: #0095ff;
    text-decoration: underline;
    font-weight: 500;
  }
`;

const TermsAndConditions = () => {
  return (
    <WrapperDiv>
      <span>By signing up, you agree to Shoflo&apos;s </span>
      <ModalFooterLink
        target="_blank"
        to="https://www.cvent.com/en/cvent-event-cloud-terms-use"
        rel="noopener noreferrer"
        data-testid="tclink"
      >
        Terms & Conditions
      </ModalFooterLink>
      <span> and </span>
      <ModalFooterLink
        className="link"
        target="_blank"
        to="https://www.cvent.com/en/privacy-policy"
        rel="noopener noreferrer"
        data-testid="pplink"
      >
        Privacy Policy
      </ModalFooterLink>
    </WrapperDiv>
  );
};

export default TermsAndConditions;
